import * as moment from 'moment';
import { App } from 'ionic-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { CalendarEvent } from 'angular-calendar';
import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { Injectable } from '@angular/core';
import {
  EventsServiceProvider,
  SellionsEvent,
} from '../events-service/events-service';
import {
  FilterServiceProvider,
  FilterType,
} from '../../../core/services/filter-service/FilterServiceProvider';

@Injectable()
export class CalendarServiceProvider {
  private _selectedDate: BehaviorSubject<moment.Moment> =
    new BehaviorSubject<moment.Moment>(moment());
  public readonly selectedDate$: Observable<moment.Moment> =
    this._selectedDate.asObservable();

  private _currentEvents: BehaviorSubject<CalendarEvent[]> =
    new BehaviorSubject<CalendarEvent[]>([]);
  public readonly currentEvents$: Observable<CalendarEvent[]> =
    this._currentEvents.asObservable();

  private _loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true,
  );
  public readonly loading$: Observable<boolean> = this._loading.asObservable();

  private _lastUpdateDate: moment.Moment = moment();

  constructor(
    private app: App,
    private clientService: ClientServiceProvider,
    private eventsService: EventsServiceProvider,
    private filterService: FilterServiceProvider,
  ) {
    this.filterService.subscribe(FilterType.CALENDAR, () =>
      this._loading.next(false),
    );
    this.eventsService.subscribe((events: SellionsEvent[]) => {
      this.eventsService.employeeId.subscribe((id) => {
        this._currentEvents.next(this.getMappedEvents(events, id));
        this._loading.next(false);
      });
    });
  }

  private getMappedEvents(
    events: SellionsEvent[],
    employeeId: number,
  ): CalendarEvent[] {
    return this.filterByEmployeeId(events, employeeId).map((event) => ({
      start: new Date(event.startDate),
      end: moment(event.endDate).isSame(moment(event.endDate).startOf('day'))
        ? moment(event.endDate).add(-1, 'day').toDate()
        : new Date(event.endDate),
      title: event.clientName || '-',
      color: {
        primary: '#2D3E50',
        secondary: '#979797',
      },
    }));
  }

  private filterByEmployeeId(
    events: SellionsEvent[],
    employeeId: number,
  ): SellionsEvent[] {
    if (employeeId > 0) {
      return events.filter(
        (event: SellionsEvent) => event.userId === employeeId,
      );
    } else {
      return events;
    }
  }

  public nextDate(
    mode: 'forward' | 'backward',
    page: 'CalendarDayPage' | 'CalendarMonthPage',
  ): void {
    if (this._loading.getValue() === true) {
      return;
    }

    let currentDate = this._selectedDate.getValue();
    currentDate.add(
      mode === 'forward' ? 1 : -1,
      page === 'CalendarDayPage' ? 'days' : 'months',
    );
    this._selectedDate.next(currentDate);
    this.handleEventsFetching();
  }

  public setDate(date: Date): void {
    this._selectedDate.next(moment(date));
    this.handleEventsFetching();
  }

  public showEventDetail(event: SellionsEvent): void {
    const client: IClientModel = this.clientService.getById(event.clientId);
    this.app.getRootNav().push('EventsPage', { event, client, calendar: true });
  }

  private handleEventsFetching(): void {
    let currentDate = moment(this._selectedDate.getValue());
    if (
      Math.abs(currentDate.get('month') - this._lastUpdateDate.get('month')) > 1
    ) {
      this._loading.next(true);
      console.log('loading');
      this.filterService.setFilter(
        FilterType.CALENDAR,
        Object.assign(this.filterService.getFilter(FilterType.CALENDAR), {
          month: currentDate.format('YYYY-MM-DD'),
        }),
      );
      this._lastUpdateDate = currentDate;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/services/calendar-service/calendar-service.ts